<template>
	<div id="home">
		<!-- HEADER -->
		<header id="headTop" class="headerMain">
			<div class="headContainer">
				<div class="logoBox">
					<img
						src="../assets/img/logos/VEGblanc.png"
						title="La vie économique gimontoise"
						alt="Logo du site vie économique gimontoise"
					/>
				</div>

				<nav>
					<router-link id="hplHeaderNavTopAbout" to="/a-propos.html">À propos</router-link>
					<router-link id="hplHeaderNavTopAddressbook" to="/liste.html">Acteurs économiques</router-link>
					<router-link id="hplHeaderNavTopContact" to="/contact.html">Contact</router-link>

					<a
						class="pocket"
						href="https://app.panneaupocket.com/ville/1884318079-gimont-32200"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img
							class="logoPocket"
							src="../assets/img/logos/logo-panneauPocket.png"
							alt="Logo de l'application Panneau Pocket"
						/>
					</a>

					<!-- <a
                    id="hplHeaderNavTopLogin"
                    class="blackBtn mo"
                    @click="showHideModal('connectUser');"
                    >Me Connecter</a> -->
				</nav>

				<div class="phoneIcons">
					<!-- <a id="hplHeaderNavPhoneLogin" @click="showHideModal('connectUser');">
                    <i class="fas fa-user"></i>
                    </a> -->
					<a id="hplHeaderNavPhoneToggle1" @click="phoneNav()">
						<i class="fas fa-bars"></i>
					</a>
				</div>
			</div>

			<div class="phoneMenu">
				<a id="hplHeaderNavPhoneToggle2" @click="phoneNav()">
					<i class="fal fa-times"></i>
				</a>
				<nav>
					<router-link id="hplHeaderNavPhoneAbout" to="/a-propos.html">À propos</router-link>
					<router-link id="hplHeaderNavPhoneAddressbook" to="/liste.html">Acteurs économiques</router-link>
					<router-link id="hplHeaderNavPhoneContact" to="/contact.html">Contact</router-link>
					<a
						class="linkPocket"
						href="https://app.panneaupocket.com/ville/1884318079-gimont-32200"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img
							class="logoPocketPhone"
							src="../assets/img/logos/logo-panneauPocket.png"
							alt="Logo de l'application Panneau Pocket"
						/>
					</a>
				</nav>
			</div>
		</header>

		<!-- CONTENT -->
		<section id="pageMain">
			<div class="logoMobile">
				<div class="thImgBis">
					<img
						src="../assets/img/logos/Je-soutiens-mon-commerce-ok.png"
						alt="Logo de l'association des commerçants de Gimont : Ensemble gimont"
					/>
				</div>
				<div class="thImgBis">
					<img src="../assets/img/content/Logo-Gimont.png" alt="Logo de la mairie de Gimont" />
				</div>
			</div>

			<div class="thImg">
				<img
					src="../assets/img/logos/Je-soutiens-mon-commerce-ok.png"
					alt="Logo de l'association des commerçants de Gimont : Ensemble gimont"
				/>
				<img src="../assets/img/content/Logo-Gimont.png" alt="Logo de la mairie de Gimont" />
			</div>
			<section class="findSection">
				<div>
					<h1>
						Consommer local, ça fait toute la différence;
						<br />Qualité, savoir faire & authenticité
					</h1>
					<h2>
						Découvrez nos producteurs locaux, les artisans, les commerces et professions libérales près de chez vous
					</h2>

					<div class="locationSection">
						<div>
							<label>Recherche par mot-clef</label>
							<br />
							<div class="searchBox">
								<input type="text" placeholder="Recherche par mot-clef" v-model="searchKeyWord" />
								<router-link
									v-if="searchKeyWord"
									:to="{
										name: 'ListSearch',
										params: {
											search: deleteSpace(deleteParenthesis(searchKeyWord.toLowerCase())),
										},
									}"
									class="submitBtn"
								>
									<i class="fas fa-search"></i>
								</router-link>
							</div>
						</div>

						<div class="filterInput">
							<label>Recherchez un commerce</label>
							<br />

							<div class="searchBox">
								<input
									type="text"
									list="filtreComList"
									placeholder="Recherchez un commerce"
									v-model="searchTrader"
								/>
								<router-link
									v-if="searchTrader"
									:to="{
										name: 'ListSearch',
										params: {
											search: deleteSpace(deleteParenthesis(searchTrader.toLowerCase())),
										},
									}"
									class="submitBtn"
								>
									<i class="fas fa-search"></i>
								</router-link>

								<datalist id="filtreComList">
									<option v-for="activity in activityArray" :key="activity" :value="activity">
										{{ activity }}
									</option>
								</datalist>
							</div>
						</div>
					</div>
					<router-link to="/liste.html" class="blackBtn">Voir la liste</router-link>
				</div>
			</section>

			<section class="situationsSection">
				<article>
					<img
						src="../assets/img/content/Mobile-payments-bro.png"
						alt="image illustration commercant moustachu Gimont "
					/>

					<p>
						Je suis un commerçant,
						<br />un producteur, un artisan, <br />
						un professionnel libéral... <br />
						et souhaite proposer mes services
					</p>

					<a class="yellowBtn" @click="showHideModal('signInUserSeller')">Je m'inscris</a>
				</article>

				<article>
					<img
						src="../assets/img/content/Producthunt-bro.png"
						alt="image de fond - Gimont 32 la vie économique gimontoise"
					/>

					<p>
						Je suis citoyen et
						<br />cherche des produits locaux
					</p>
					<a @click="togglePopup = !togglePopup" class="yellowBtn">Je m'inscris</a>
				</article>
			</section>

			<popup v-if="togglePopup" :open_close.sync="togglePopup"> </popup>

			<section class="aboutSection">
				<article>
					<img src="../assets/img/content/gimont-city.png" alt="Illustration de Gimont par Stéphanie Cerrajero" />
					<div>
						<h3>
							La vie économique
							<br />Gimontoise, c'est quoi ?
						</h3>
						<p>
							<b>Vie-économique-Gimontoise</b> est un site de promotion et d’accompagnement du
							<b>commerce de proximité</b>, des <b>artisans</b> et des <b>professions libérales</b> sur une
							plateforme digitalisée, mutualisée évolutive et performante.
						</p>
						<p>
							Son objectif est le <b>développement</b> et l’<b>animation</b> de l’offre <b>commerciale</b> et des
							services sur la commune de Gimont.
						</p>
					</div>
				</article>
				<!-- <router-link to="/" class="blackBtn">Voir le guide</router-link> -->
			</section>
		</section>

		<!-- FOOTER -->
		<footer id="footBot" class="footerMain">
			<div class="footContainer">
				<div class="logoBar">
					<a href="https://www.facebook.com/tousensemble.asso.commercants.gimont/" target="_blank" rel="noopener">
						<img
							src="../assets/img/logos/Je-soutiens-mon-commerce-ok.jpg"
							alt="Logo de l'association des commerçants de Gimont : Ensemble gimont"
						/>
					</a>
					<a href="http://www.gimont.fr/accueil_mairie.vdom" target="_blank" rel="noopener">
						<img src="../assets/img/partners/gimont.png" alt="Blason de la commune de Gimont" />
					</a>
					<a href="http://www.3cag.fr/" target="_blank" rel="noopener">
						<img
							src="../assets/img/partners/LOGO_3CAG.jpg"
							alt="Logo de la communauté de communes coteaux arrats gimone (3CAG)"
						/>
					</a>
					<a href="https://www.graphibox.biz/" target="_blank" rel="noopener">
						<img src="../assets/img/partners/graphibox.png" alt="Logo de l'agence Graphibox" />
					</a>
				</div>
				<nav>
					<router-link id="hplFooterNavLegalsNotices1" class="footerLink" to="/mentions-legales.html"
						>Conditions générales d'utilisation</router-link
					>
					<a href="https://gestion.vie-economique-gimont.fr" target="_blank" rel="noopener noreferrer"
						>Accès console commerçants</a
					>

					<p class="credits">
						Offert par
						<a href="https://www.graphibox.biz/" target="_blank" rel="noopener noreferrer">GRAPHIBOX</a>
						2020 - Tous droits réservés
					</p>
				</nav>
			</div>
		</footer>

		<!-- DISPLAY MSG -->
		<div id="DisplayMsg"></div>

		<!-- CONNECT USER -->
		<section id="connectUser" class="inscriptionPanel">
			<i class="fal fa-times btnClose" @click="showHideModal('connectUser')"></i>
			<div class="etapesPanel">
				<router-link to="/" class="logoComm">
					<img src="../assets/img/logos/VEG2.png" alt="Logo du site vie économique gimontoise" />
				</router-link>

				<img src="../assets/img/content/Chatting-bro.png" alt="Illustation commande depuis canapé" class="hideThousand" />

				<h3>Pas encore membre ?</h3>
				<a
					class="blackBtn"
					@click="
						showHideModal('signInUser');
						showHideModal('connectUser');
					"
					>Je m'inscris</a
				>
			</div>

			<div class="formDiv">
				<article>
					<h4>Connectez-vous</h4>
					<div>
						<label for>Votre Identifiant</label>
						<!-- 2019.1.115.45 -->
						<input
							id="incLogin_tbxLogin"
							name="tbxLogin"
							class="riTextBox riEmpty"
							placeholder="Identifiant"
							type="text"
						/>
					</div>

					<div class="connectPassBox">
						<label for>Votre Mot de passe</label>
						<input
							id="incLogin_tbxPassword"
							name="tbxPassword"
							size="20"
							class="riTextBox riEmpty"
							type="password"
							placeholder="******"
						/>
					</div>
					<div style="margin-top: 2rem">
						<button
							type="submit"
							name="btnSubmitLogin"
							value="Me Connecter"
							id="incLogin_btnSubmitLogin"
							class="RadButton RadButton_Default rbButton rbRounded rbIconButton"
						>
							<span class="rbText">Me Connecter</span>
							<input id="incLogin_btnSubmitLogin_ClientState" name="btnSubmitLogin_ClientState" type="hidden" />
						</button>
					</div>
				</article>

				<div class="dejaMembre">
					<p>
						Pas encore membre ?
						<a
							@click="
								showHideModal('signInUser');
								showHideModal('connectUser');
							"
							>Inscrivez-vous</a
						>
					</p>
					<a class="backBtn" @click="showHideModal('connectUser')">Retour</a>
				</div>
			</div>
		</section>

		<!-- SIGN IN USER -->
		<section id="signInUser" class="inscriptionPanel">
			<div class="commercantPart">
				<i class="fal fa-times btnClose" @click="showHideModal('signInUser')"></i>
				<router-link to="/" class="logoComm">
					<img src="../assets/img/logos/VEG2.png" alt="Logo du site vie économique gimontoise" />
				</router-link>
				<img src="../assets/img/content/Producthunt-bro.png" alt="Illustration commerçant Gimont et sa moustache" />
				<p>
					Je suis un commerçant,
					<br />un producteur, un artisan... <br />et souhaite proposer mes services
				</p>
				<p>
					Je suis un particulier
					<br />et je souhaite voir les offres près de <br />chez moi
				</p>
			</div>

			<div class="formDiv">
				<article>
					<h4>
						Dites-nous tout pour faire
						<br />partie de la famille
					</h4>
					<div>
						<label>Vous êtes</label>
					</div>
					<div class="box">
						<section>
							<a
								class="blackBtn"
								@click="
									showHideModal('signInUser');
									showHideModal('signInUserCustomer');
								"
								>Particulier</a
							>
						</section>
						<section>
							<a
								class="blackBtn"
								@click="
									showHideModal('signInUser');
									showHideModal('signInUserSeller');
								"
								>Commerçant</a
							>
						</section>
					</div>
				</article>

				<div class="dejaMembre">
					<p>
						Déjà membre ?
						<a
							@click="
								showHideModal('signInUser');
								showHideModal('connectUser');
							"
							>Connectez-vous</a
						>
					</p>
					<a class="backBtn" @click="showHideModal('signInUser')">Retour</a>
				</div>
			</div>
		</section>

		<!-- SIGN IN USER SELLER -->
		<section id="signInUserSeller" class="inscriptionPanel">
			<div class="commercantPart">
				<i class="fal fa-times btnClose" @click="showHideModal('signInUserSeller')"></i>
				<router-link to="/" class="logoComm">
					<img src="../assets/img/logos/VEG2.png" alt="Logo du site vie économique gimontoise" />
				</router-link>
				<img src="../assets/img/content/Mobile-payments-bro.png" alt="Illustration commercant Gimont et sa moustache" />
				<p>
					Je suis un commerçant,
					<br />un producteur, un artisan... <br />et souhaite proposer mes services
				</p>
			</div>

			<div class="formDiv">
				<!-- PANNEAU ERREUR / REUSSITE -->
				<div class="errorpanel" v-if="errors.length || success.length" @click="errors = []">
					<div class="close">X</div>
					<div v-if="errors && errors.length" class="error">
						<ul>
							<li v-for="error in errors" :key="error" v-html="error"></li>
						</ul>
					</div>
					<div v-if="success && success.length" class="success" @click="success = []">
						<ul>
							<li v-for="yes in success" :key="yes" v-html="yes"></li>
						</ul>
					</div>
				</div>
				<article>
					<h4>
						Dites-nous tout pour faire
						<br />partie de la famille
					</h4>

					<div class="box">
						<section>
							<label for>Nom</label>
							<input
								id="incLoginRegister_tbxSellerLastName"
								name="tbxSellerLastName"
								class="riTextBox riEmpty"
								placeholder="Votre nom"
								type="text"
								v-model="lastnameRegister"
							/>
						</section>
						<section>
							<label for>Prénom</label>
							<input
								id="incLoginRegister_tbxSellerFirstName"
								name="tbxSellerFirstName"
								class="riTextBox riEmpty"
								placeholder="Votre prénom"
								type="text"
								v-model="firstnameRegister"
							/>
						</section>
					</div>

					<div class="box">
						<section>
							<label for>Nom de l'entreprise</label>
							<input
								id="incLoginRegister_tbxSellerCompanyName"
								name="tbxSellerCompanyName"
								class="riTextBox riEmpty"
								placeholder="Nom de votre entreprise"
								type="text"
								v-model="companyNameRegister"
							/>
						</section>
					</div>

					<div class="box">
						<section>
							<label for>Email</label>
							<input
								id="incLoginRegister_tbxSellerCompanyPhone"
								name="tbxSellerCompanyPhone"
								class="riTextBox riEmpty"
								placeholder="Email de votre entreprise"
								type="text"
								v-model="emailRegister"
							/>
						</section>
					</div>

					<div style="margin-top: 2rem">
						<button
							type="submit"
							name="btnSubmitSellerRegister"
							value="Me Connecter"
							id="incLoginRegister_btnSubmitSellerRegister"
							class="RadButton RadButton_Default rbButton rbRounded rbIconButton"
							@click="checkForm()"
						>
							<span class="rbText">M'inscrire</span>
						</button>
					</div>
				</article>

				<!-- <div class="dejaMembre">
          <p>
            Déjà membre ?
            <a
              @click="showHideModal('signInUserSeller'); showHideModal('connectUser');"
            >Connectez-vous</a>
          </p>
          <a
            class="backBtn"
            @click="showHideModal('signInUserSeller'); showHideModal('signInUser')"
          >Retour</a>
        </div> -->
			</div>
		</section>

		<!-- SIGN IN USER CUSTOMER -->
		<section id="signInUserCustomer" class="inscriptionPanel">
			<i class="fal fa-times btnClose" @click="showHideModal('signInUserCustomer')"></i>
			<div class="etapesPanel">
				<router-link to="/" class="logoComm">
					<img src="../assets/img/logos/VEG2.png" alt="Logo du site vie économique gimontoise" />
				</router-link>

				<img src="../assets/img/content/Chatting-bro.png" alt="Illustation commande depuis canapé" />

				<div class="blackCircles">
					<div class="bigcircle"></div>
					<div class="trait"></div>
					<div class="smcircle smcA"></div>
					<div class="trait"></div>
					<div class="smcircle smcB"></div>
					<div class="trait"></div>
					<div class="smcircle smcC"></div>
				</div>
			</div>

			<div class="formDiv">
				<article>
					<h4>
						Rejoignez-nous
						<br />et on vous tiens au jus
					</h4>

					<div class>
						<label for>Votre identifiant ou adresse email</label>
						<input
							id="incLoginRegister_tbxCustomerAddressCity"
							name="tbxCustomerAddressCity"
							class="riTextBox riEmpty fullInput"
							placeholder="Votre identifiant"
							type="text"
						/>
					</div>

					<div class="box">
						<section>
							<label for>Mot de passe</label>
							<input
								id="incLoginRegister_tbxCustomerEmail"
								name="tbxCustomerEmail"
								class="riTextBox riEmpty"
								placeholder="********"
								type="password"
							/>
						</section>
						<section>
							<label for>Confirmez le mot de passe</label>
							<input
								id="incLoginRegister_tbxCustomerPassword"
								name="tbxCustomerPassword"
								class="riTextBox riEmpty"
								placeholder="********"
								type="password"
							/>
						</section>
					</div>
					<div class="boxCheckbox">
						<input type="checkbox" name id />
						<label for>Je souhaite recevoir des informations de l'association des commerçants de Gimont</label>
					</div>
					<div class="boxCheckbox">
						<input type="checkbox" name id />
						<label for>Je souhaite recevoir des informations des commerçants de Gimont</label>
					</div>
					<div class="boxCheckbox">
						<input type="checkbox" name id />
						<label for>J'ai lu les conditions d'utilisation et je les accepte</label>
					</div>

					<div style="margin-top: 2rem">
						<button
							type="submit"
							name="btnSubmitCustomerRegister"
							value="Me Connecter"
							id="incLoginRegister_btnSubmitCustomerRegister"
							class="RadButton RadButton_Default rbButton rbRounded rbIconButton"
						>
							<span class="rbText">Me Connecter</span>
							<input
								id="incLoginRegister_btnSubmitCustomerRegister_ClientState"
								name="btnSubmitCustomerRegister_ClientState"
								type="hidden"
							/>
						</button>
					</div>
				</article>

				<div class="dejaMembre">
					<p>
						Déjà membre ?
						<a
							@click="
								showHideModal('signInUserCustomer');
								showHideModal('connectUser');
							"
							>Connectez-vous</a
						>
					</p>
					<a
						class="backBtn"
						@click="
							showHideModal('signInUserCustomer');
							showHideModal('signInUser');
						"
						>Retour</a
					>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import { titleMixin } from "../mixins/titleMixin";
import { shopMixin } from "../mixins/shopMixin";
import { formMixin } from "../mixins/formMixin";
import axios from "axios";
import popup from "../components/Popup";

export default {
	metaInfo: {
		meta: [
			{
				vmid: "description",
				name: "description",
				content:
					"Consommer local ça fait toute la différence. Qualité, savoir faire et authenticité. Découvrez nos producteurs locaux, les artisans et les commerces près de chez vous. Vie économique gimontoise à Gimont dans le Gers",
			},
			{
				vmid: "keywords",
				name: "keywords",
				content:
					"Contact, Vie économique, Partenaires gimontois, Commerces, Producteurs locaux, Artisans, Vie économique gimontoise, Gimont, Gers",
			},
		],
	},
	name: "Home",
	mixins: [titleMixin, shopMixin, formMixin],
	components: {
		popup,
	},
	data() {
		return {
			title: "Vie économique gimontoise Gimont Gers 32",
			hydroalcoolique: false,
			searchKeyWord: "",
			searchTrader: "",

			lastnameRegister: "",
			firstnameRegister: "",
			companyNameRegister: "",
			emailRegister: "",

			success: "",
			errors: "",
			togglePopup: false,
		};
	},
	methods: {
		showHideModal(targetId) {
			// console.log(targetId);
			// return false;
			let modal = document.getElementById(targetId);
			if (modal.style.display === "none" || modal.style.display === "") {
				modal.setAttribute("style", "display:flex");

				modal.animate([{ transform: "translateX(-100vw)" }, { transform: "translateX(0)" }], {
					duration: 500,
				});
			} else {
				setTimeout(() => {
					modal.setAttribute("style", "display:none");
					modal.setAttribute("style", "transform:translateX(-100vw)");
				}, 290);
				modal.animate([{ transform: "translateX(0)" }, { transform: "translateX(-100vw)" }], {
					duration: 500,
				});
			}
		},
		phoneNav() {
			let baseHeader = document.getElementsByClassName("headContainer")[0];
			let navPhone = document.getElementsByClassName("phoneMenu")[0];
			this.hydroalcoolique = !this.hydroalcoolique;

			if (this.hydroalcoolique) {
				baseHeader.style.display = "none";
				navPhone.style.display = "block";
			} else {
				baseHeader.style.display = "flex";
				navPhone.style.display = "none";
			}
		},
		checkForm: function() {
			// if required fields are set
			if (
				this.lastnameRegister &&
				this.firstnameRegister &&
				this.companyNameRegister &&
				this.emailRegister &&
				this.emailIsvalid(this.emailRegister)
			) {
				// let value = this.prepareMail();
				this.sendMail();
				this.success = [];
				this.success.push("Votre demande a bien été prise en compte. Nous vous recontacterons dans les meilleurs délais");
				return true;
			} else {
				this.errors = [];
				this.errors.push("<b>Avant d'envoyer votre demande, vous devez remplir les champs suivants :</b>");
				if (!this.lastnameRegister) {
					this.errors.push("Nom");
				}
				if (!this.firstnameRegister) {
					this.errors.push("Prénom");
				}
				if (!this.companyNameRegister) {
					this.errors.push("Nom d'entreprise");
				}
				if (!this.emailRegister) {
					this.errors.push("Email");
				} else if (!this.emailIsvalid(this.emailRegister)) {
					this.errors.push("Email invalide");
				}
			}
		},
		sendMail() {
			axios
				.post(
					"/inscription-commerce.aspx",
					{
						contact: this.emailRegister,
						nom: this.lastnameRegister,
						prenom: this.firstnameRegister,
						nomEntreprise: this.companyNameRegister,
					},
					{
						headers: {
							"Content-Type": "application/x-www-form-urlencoded",
						},
					}
				)
				.then(function(response) {
					console.log(response);
				})
				.catch(function(error) {
					console.log(error);
				});
		},
	},
};
</script>

<style scoped>
/* HEADER */
.headerMain {
	background-image: url("../assets/img/wallpapers/fondocre.png");
	background-size: 100% 100%;
	background-position: bottom;
	background-repeat: no-repeat;
	display: flex;
	align-items: center;
	position: relative;
}
.headContainer {
	position: relative;
	display: flex;
	width: 100%;
	justify-content: space-evenly;
	align-items: center;
	margin-bottom: 6rem;
	margin-top: 1rem;
}
header > img {
	width: 100%;
}
.logoBox img {
	width: 20vw;
}
header nav {
	display: flex;
	align-items: center;
}
header nav a {
	font-size: 1.1rem;
	margin: 0 0.5rem;
}
header nav .logoPocket {
	width: 15%;
}

header nav a:hover:not(.blackBtn),
a.footerLink:hover {
	letter-spacing: 1px;
}

/* CONTENT */
#pageMain {
	position: relative;
}
.thImg {
	position: absolute;
	width: 100%;
	display: flex;
	justify-content: space-between;
}
.thImg img {
	width: 14%;
	object-fit: contain;
}
.thImgBis {
	display: none;
}
.logoPocket {
	width: 15%;
}
.phoneMenu a.linkPocket {
	text-align: center;
	width: 8%;
}
.logoPocketPhone {
	width: 100%;
}
.situationsSection {
	display: flex;
	justify-content: space-evenly;
	width: 80%;
	margin: auto;
}

.situationsSection article img {
	width: 20vw;
	height: 20vw;
	object-fit: contain;
}

.situationsSection p {
	font-size: 1.5rem;
	font-weight: 700;
	margin-top: 0;
}

.situationsSection article {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	text-align: center;
}

.findSection {
	position: relative;
	margin-top: 1rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.findSection > img {
	width: 100%;
}

.findSection > div {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.findSection h2 {
	margin: 0 0 1rem;
}

.locationSection {
	background-color: white;
	display: flex;
	align-items: center;
	justify-content: space-evenly;
	width: 60vw;
	height: 200px;
	box-shadow: 2px 1px 4px 2px #ccc;
}

.locFilter > div {
	display: flex;
	align-items: center;
}

.searchBox {
	display: flex;
}

.locationSection p {
	margin: 0 1rem;
}

.submitBtn i {
	background-color: #d89747;
	height: 42px;
	width: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.locationSection .yellowBtn {
	display: flex;
	align-items: center;
	width: fit-content;
}

.locationSection i {
	font-size: 1.5em;
	margin-right: 0.5rem;
}

.locationSection label {
	color: #bbb;
	margin-bottom: 1rem;
}

.locationSection {
	margin-bottom: 1rem;
}

.filterInput input {
	width: 250px;
}
.aboutSection {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 8rem;
}

.aboutSection article {
	display: flex;
	justify-content: space-between;
	width: 65vw;
}

.aboutSection img,
.aboutSection div {
	width: 49%;
	object-fit: contain;
}

.aboutSection div {
	margin-left: 2rem;
}

.aboutSection h3 {
	font-size: 1.8rem;
}

.aboutSection p {
	margin-left: 0.5rem;
}

.aboutSection .blackBtn {
	margin-top: 3rem;
}

/* FOOTER */
.footerMain {
	background-image: url("../assets/img/wallpapers/fondfooter-ocre.png");
	background-repeat: no-repeat;
	margin-top: 6rem;
	position: relative;
	display: flex;
	align-items: flex-end;
}
.footContainer {
	position: relative;
	display: flex;
	width: 100%;
	justify-content: space-evenly;
	align-items: center;
	--margin-top: 6rem;
	min-height: 82px;
	margin-bottom: 1rem;
}
footer > img {
	width: 100%;
}
footer nav {
	position: relative;
	text-transform: uppercase;
	width: 100%;
	text-align: center;
	margin-top: 4rem;
}
footer nav a {
	margin: 0 1rem;
}
footer .credits {
	font-size: 0.7rem;
	color: white;
}
footer .credits a {
	margin: 0;
	transition: all 0.5s ease;
}
footer .credits a:hover {
	font-size: 0.9rem;
	transition: all 0.5s ease;
}
footer .logoBar {
	position: absolute;
	top: -10px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	justify-content: center;
}
footer .logoBar a {
	margin: 0 0.5rem;
}
footer .logoBar img {
	height: 50px;
	object-fit: contain;
}

/*************************
    MAX-WIDTH : 1500PX
*************************/
@media all and (max-width: 1500px) {
	/* HOME - CONTENT */
	.findSection .blackBtn {
		margin-top: 1rem;
	}
	.locationSection {
		height: 170px;
	}
	.aboutSection div {
		width: 40%;
	}
	.aboutSection img {
		width: 59%;
	}
}

/*************************
    MAX-WIDTH : 1300PX
*************************/
@media all and (max-width: 1300px) {
	/* HOME - CONTENT */
	.situationsSection p {
		font-size: 1.2rem;
	}
	.locationSection {
		width: 80vw;
	}
	h2,
	.findSection h2 {
		font-size: 1.6rem;
		margin: 1rem;
	}
	.aboutSection article {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		width: 80%;
	}
	.aboutSection img,
	.aboutSection div {
		width: 100%;
		margin: 0;
	}
	.aboutSection p {
		margin: 0;
	}
}

/*************************
    MAX-WIDTH : 1100PX
*************************/
@media all and (max-width: 1100px) {
	/* HOME - FOOTER */
	footer nav a {
		font-size: 0.9rem;
	}
	footer .logoBar img {
		height: 40px;
		object-fit: contain;
	}
}

/*************************
    MAX-WIDTH : 1000PX
*************************/
@media all and (max-width: 1000px) {
	/* HOME - HEADER */
	header > img {
		height: 34vw;
		object-fit: cover;
	}
	.headContainer nav {
		display: none;
	}
	.headContainer img {
		width: 60vw;
	}

	/* HOME - CONTENT */
	.situationsSection {
		flex-wrap: wrap;
	}
	.situationsSection article img {
		width: 45vw;
		height: 45vw;
	}
	.locationSection {
		width: 95vw;
		flex-direction: column;
		height: 260px;
		position: relative;
	}
	.locationSection input {
		width: 80vw;
		height: 50px;
	}
	.submitBtn i {
		height: 52px;
		width: 50px;
	}
	.findSection {
		position: relative;
	}
	.findSection > div {
		position: relative;
	}
	.findSection > img {
		display: none;
	}

	/* HOME - FOOTER */
	footer img {
		height: 130px;
	}
	footer nav {
		top: 50%;
	}
	footer i {
		font-size: 1.8em;
	}
	footer nav a {
		font-size: 0.7rem;
		margin: 0 8px;
	}
}

/*************************
    MAX-WIDTH : 768PX
*************************/
@media all and (max-width: 768px) {
	/* HOME - CONTENT */
	.thImg {
		display: none;
	}
	.findSection h1 {
		display: none;
	}
	.thImgBis {
		display: block;
		width: 30%;
	}
	.logoMobile {
		display: flex;
		justify-content: space-around;
		align-items: center;
	}
	.thImgBis img {
		width: 100%;
	}
}

/*************************
    MAX-WIDTH : 500PX
*************************/
@media all and (max-width: 500px) {
	/* HOME - HEADER */
	header {
		display: block;
	}
	.headContainer {
		margin-bottom: 1rem;
		margin-top: 0;
	}
	header .blackBtn {
		margin-top: 1rem;
		display: table;
	}
	.head .left > div {
		margin-top: 50px;
	}
	.head .left > div {
		padding: 0;
	}

	/* HOME - CONTENT */
	.locationSection input {
		width: 70vw;
		margin-left: 2vw;
		padding-left: 2vw;
	}
	.findSection {
		display: block;
		margin: 0;
	}
	.situationsSection article img {
		width: 94vw;
		height: 94vw;
	}
	.findSection h2 {
		font-size: 1rem;
	}
}
</style>
